<div
  (click)="onSectionClicked()"
  class="section-wrapper"
  [class.section-wrapper--selectable]="section().sectionId !== null"
  [class.section-wrapper--selected]="sectionFilter()?.sectionIds.includes(section().sectionId)"
>
  <div class="section" [class.section--bordered]="section().sectionId !== null">
    @if (section().label) {
      <div (click)="onSectionLabelClicked($event)" class="section-label">
        <div class="section-speaker">
          <span>{{ section().label }}</span>
        </div>
      </div>
    }

    <div class="section-text-wrapper">
      @if (!isPlaybackDisabled() && section().playbackDisplay) {
        <div (click)="onSectionTextClicked()" class="section-playback-offset">
          {{ section().playbackDisplay }}
        </div>
      }
      <div
        class="section-text"
        (click)="onSectionTextClicked()"
        [innerHTML]="section().value"
      ></div>
    </div>
  </div>
</div>
